import {
  useSearchPageFiltersQueryArgs,
  useSearchPageQueryArgs,
} from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/useSearchPageQueryArgs";
import { useSearchPageIsOnFirstPage } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsOnFirstPage";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export const usePrefetchSearchPage = () => {
  const queryClient = useQueryClient();
  const { productsQueryArgs } = useSearchPageQueryArgs();
  const { filtersQueryArgs } = useSearchPageFiltersQueryArgs();
  const isOnFirstPage = useSearchPageIsOnFirstPage();

  return useCallback(() => {
    // Only prefetch products for first page because the page_size field of the request depends on the response from the banners API for other pages
    if (isOnFirstPage) {
      queryClient.prefetchQuery({
        queryKey: productsQueryArgs.key,
        queryFn: productsQueryArgs.fn,
        staleTime: productsQueryArgs.staleTime,
      });
    }

    queryClient.prefetchQuery({
      queryKey: filtersQueryArgs.key,
      queryFn: filtersQueryArgs.fn,
      staleTime: filtersQueryArgs.staleTime,
    });
  }, [
    filtersQueryArgs.fn,
    filtersQueryArgs.key,
    filtersQueryArgs.staleTime,
    isOnFirstPage,
    productsQueryArgs.fn,
    productsQueryArgs.key,
    productsQueryArgs.staleTime,
    queryClient,
  ]);
};
